// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Badge {
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  color: var(--color-content-neutral);
  border-radius: 1em;
  transition-property: background-color;
  transition-duration: 0.2s;
}
.n-Badge--color-text {
  background-color: var(--color-content-base);
}
.n-Badge--color-text-secondary {
  background-color: var(--color-content-secondary);
}
.n-Badge--color-text-alt {
  background-color: var(--color-content-secondary);
}
.n-Badge--color-warning {
  background-color: var(--color-warning-content-base);
}
.n-Badge--color-error {
  background-color: var(--color-error-content-base);
}
.n-Badge--color-success {
  background-color: var(--color-success-content-base);
}
.n-Badge--color-info {
  background-color: var(--color-info-content-base);
}
.n-Badge--color-disabled {
  background-color: var(--color-content-disabled);
}
.n-Badge--color-inherit {
  color: inherit;
  background: currentColor;
}
.n-Badge--color-inherit .n-Badge__shape {
  color: var(--color-content-neutral);
}
.n-Badge__shape {
  display: block;
  padding: var(--n-badge-shape-padding, 0.15em 0.5em);
  font-size: 75%;
  line-height: 1.2;
}
.n-Badge__content {
  line-height: 1;
  font-weight: 600;
  letter-spacing: -0.15px;
}
.n-Badge--vertical {
  writing-mode: vertical-rl;
  vertical-align: baseline;
  /* vertical-align: middle is broken with writing-mode: vertical-rl in Chrome. */
}
.n-Badge--vertical .n-Badge__shape {
  /* Text top is on the right in vertical mode, so we need to kind of rotate the padding and margin. */
  margin-top: 0;
  padding: var(--n-badge-shape-padding-vertical, 0.5em 0.15em);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/badge/Badge.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAJA;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;AAMF;AAHI;EAAoB,2CAAA;AAMxB;AALI;EAAoB,gDAAA;AAQxB;AAPI;EAAoB,gDAAA;AAUxB;AATI;EAAoB,mDAAA;AAYxB;AAXI;EAAoB,iDAAA;AAcxB;AAbI;EAAoB,mDAAA;AAgBxB;AAfI;EAAoB,gDAAA;AAkBxB;AAjBI;EAAoB,+CAAA;AAoBxB;AAnBI;EACE,cAAA;EACA,wBAAA;AAqBN;AAjBE;EACE,mCAAA;AAmBJ;AAhBE;EACE,cAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;AAkBJ;AAfE;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;AAiBJ;AAdE;EACE,yBAAA;EACA,wBAAA;EAgBF,+EAA+E;AACjF;AAdE;EAgBA,oGAAoG;EAdlG,aAAA;EACA,4DAAA;AAgBJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n@padding-sides: .5em;\n@padding-topbottom: .15em;\n\n.n-Badge {\n  display: inline-block;\n  vertical-align: middle;\n  white-space: nowrap;\n  text-align: center;\n  color: var(--color-content-neutral);\n  border-radius: 1em;\n  transition-property: background-color;\n  transition-duration: 0.2s;\n\n  &--color {\n    &-text            { background-color: var(--color-content-base); }\n    &-text-secondary  { background-color: var(--color-content-secondary); }\n    &-text-alt        { background-color: var(--color-content-secondary); }\n    &-warning         { background-color: var(--color-warning-content-base); }\n    &-error           { background-color: var(--color-error-content-base); }\n    &-success         { background-color: var(--color-success-content-base); }\n    &-info            { background-color: var(--color-info-content-base); }\n    &-disabled        { background-color: var(--color-content-disabled); }\n    &-inherit {\n      color: inherit;\n      background: currentColor;\n    }\n  }\n\n  &--color-inherit &__shape {\n    color: var(--color-content-neutral);\n  }\n\n  &__shape {\n    display: block;\n    padding: var(--n-badge-shape-padding, @padding-topbottom @padding-sides);\n    font-size: 75%;\n    line-height: 1.2;\n  }\n\n  &__content {\n    line-height: 1;\n    font-weight: @fontWeight-semibold;\n    letter-spacing: -0.15px;\n  }\n\n  &--vertical {\n    writing-mode: vertical-rl;\n    vertical-align: baseline; /* vertical-align: middle is broken with writing-mode: vertical-rl in Chrome. */\n  }\n\n  &--vertical &__shape {\n    /* Text top is on the right in vertical mode, so we need to kind of rotate the padding and margin. */\n    margin-top: 0;\n    padding: var(--n-badge-shape-padding-vertical, @padding-sides @padding-topbottom);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
